// @ts-ignore untyped import
import { handleActions } from 'flux-actions';
import FormState from 'MeetingsLib/models/FormState';
import FormPrefills from 'MeetingsBase/models/FormPrefills';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
const initialState = new FormState();
export default handleActions({
  [ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED](state, action) {
    const {
      bookInfo: {
        formPrefills,
        tokenPrefills = new FormPrefills()
      },
      customFormFields: configuredCustomFormFields
    } = action.payload;
    state = state || new FormState();

    // Priority: token > existing state > link-configured prefill
    // support "hidden field" submissions SMMC-1144
    const email = tokenPrefills.email || state.email || formPrefills.email;
    const firstName = tokenPrefills.firstName || state.firstName || formPrefills.firstName;
    const lastName = tokenPrefills.lastName || state.lastName || formPrefills.lastName;

    // Priority: token > existing state > link-configured prefill > configured defaults
    const customFormFields = configuredCustomFormFields.map((field, key) => formPrefills.getIn(['customFormFields', key], field)).merge(state.customFormFields).merge(tokenPrefills.get('customFormFields'));

    // Excludes formPrefills so owner resets restore token identity, not link-configured values
    const originalFormState = new FormState({
      email: tokenPrefills.email || state.email,
      firstName: tokenPrefills.firstName || state.firstName,
      lastName: tokenPrefills.lastName || state.lastName,
      customFormFields: state.customFormFields.merge(tokenPrefills.get('customFormFields'))
    });
    return state.merge({
      email,
      firstName,
      lastName
    }).set('customFormFields', customFormFields).set('originalFormState', originalFormState);
  },
  [ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED](state, action) {
    const {
      bookInfo: {
        formPrefills
      },
      customFormFields: configuredCustomFormFields
    } = action.payload;
    const {
      firstName,
      lastName,
      customFormFields
    } =
    // @ts-ignore fix type
    state.originalFormState.toObject();
    return state.email !== formPrefills.email ? FormState.from({
      firstName,
      lastName,
      email: state.email,
      customFormFields: configuredCustomFormFields.merge(customFormFields)
    }) : state;
  },
  [ActionTypes.SET_EMAIL_FORM](state, action) {
    return state.set('email', action.payload);
  },
  [ActionTypes.RESET_EMAIL_FORM](state) {
    return state.set('email', '');
  },
  [ActionTypes.SET_FORM_FIELD](state, action) {
    const {
      fieldName,
      fieldValue
    } = action.payload;
    if (state.has(fieldName)) {
      return state.set(fieldName, fieldValue);
    } else if (state.hasIn(['customFormFields', fieldName])) {
      return state.setIn(['customFormFields', fieldName], fieldValue);
    }
    return state;
  }
}, initialState);